module.exports = __webpack_public_path__ + "img/6.cb54b0c5.svg";